import { FC } from 'react';
import { useActivityTracker } from '@/hooks/useActivityTracker';

/**
 * A component that silently tracks user activity
 * This component should be included once at the root of the application
 */
export const ActivityTracker: FC = () => {
  // Initialize the activity tracker
  useActivityTracker();
  
  // This component doesn't render anything
  return null;
}; 